<template>
  <div class="page-container">
    <searchable-grid title="Users" :column-defs="columnDefs" :get-rows-promise="getRows" @cellDoubleClicked="onCellDoubleClicked" @gridReady="onGridReady">
      <template slot="actions">
        <el-button type="primary" icon="fa fa-plus" @click="createUserDialogVisible = true">Create User</el-button>
      </template>
    </searchable-grid>
    <el-dialog title="Create User" :visible.sync="createUserDialogVisible" :close-on-click-modal="false" width="60%">
      <user-sign-up-dialog @close="createUserDialogVisible = false" @userCreated="onUserCreated"></user-sign-up-dialog>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api';
import SearchableGrid from '@/components/grid/SearchableGrid.vue';
import { BoolFilter, FILTER_YES } from '@/components/grid/BoolFilter';
import UserSignUpDialog from '@/components/dialog-content/UserSignUp.vue';

export default {
  data() {
    return {
      createUserDialogVisible: false,
      columnDefs: [
        {
          headerName: 'Department',
          field: 'department',
          cellRenderer: (params) => {
            if (params.value !== undefined) {
              return params.value;
            }
            return '<i class="el-icon-loading"></i>';
          },
        },
        {
          headerName: 'Name',
          field: 'fullName',
        },
        {
          headerName: 'Email',
          field: 'email',
        },
        {
          headerName: 'Username',
          field: 'username',
        },
        {
          headerName: 'Phone',
          field: 'phone',
        },
        {
          headerName: 'Active?',
          field: 'active',
          valueFormatter(cell) {
            if (cell.value === undefined) return '';

            return cell.value ? 'Yes' : 'No';
          },
          filter: BoolFilter,
        },
        {
          headerName: 'Date Added',
          field: 'dateAdded',
          filter: 'date',
        },
      ],
    };
  },
  methods: {
    getRows(params) {
      return api.user.getGridData(params);
    },
    onCellDoubleClicked(event) {
      if (event.data && event.data.id) {
        this.$router.push({ name: 'user-detail', params: { userId: event.data.id } });
      }
    },
    onUserCreated(user) {
      this.$router.push({ name: 'user-detail', params: { userId: user.id } });
    },
    onGridReady(event) {
      event.api.getFilterInstance('active').setModel({
        filter: FILTER_YES,
        filterType: 'text',
        type: 'equals',
      });
    },
  },
  components: {
    SearchableGrid,
    UserSignUpDialog,
  },
};

</script>

<style lang="scss" scoped>

</style>
